import {IMuWidget} from "./IMuWidget";

export class UiBilling extends IMuWidget {
	protected forAllTickets(callback: ((bt: UiBillingTicket)=>void)) {
		for(let sw of this.muSubWidgets) {
			if (sw.ui.cUse) callback(sw as UiBillingTicket);
		}
	}

	selectAll(ev: Event, what: "O"|"V"|"all"|"none") {
		this.forAllTickets(bt => {
			let checked = false;
			switch (what) {
				case "all": checked = true; break;
				case "none": checked = false; break;
				default: checked = what == bt.type; break;
			}
			bt.ui.cUse.checked = checked;
		});
	}

	updateVisible() {
		this.forAllTickets(bt => {
			let vis = false;
			switch (bt.type) {
				case "V": vis = this.ui.cViewV.checked; break;
				case "O": vis = this.ui.cViewO.checked; break;
			}
			bt.container.style.display = vis ? null : 'none';
		});
	}

	cDetailToggle_change() {
		//
		// ,
		//
		this.ui.table.classList.toggle("detail-hide", !this.ui.cDetailToggle.checked);
		this.ui.table.classList.toggle("detail-show", this.ui.cDetailToggle.checked);
	}
}

export class UiBillingTicket extends IMuWidget {
	public type: string;
}

export class UiBillingItem extends IMuWidget {

}
